import React from "react";
import { useNavigate } from "react-router-dom";

const InternationalCurriculumDevelopment = () => {
  const navigate = useNavigate();

  return (
    <section className="menu-section-bg">
      <div className="menu-container">

        {/* ===== HEADER ===== */}
        <div className="product-subtitleBg-header">
          <h1 className="product-titleBg">
            International Curriculum Development
          </h1>
          <p className="product-subtitleBg">
            Design and implement globally recognized academic curricula that
            meet international standards and foster holistic student
            development.
          </p>
        </div>

        {/* ===== OVERVIEW ===== */}
        <div className="product-and-sol-mainCard ps-two-column-grid product-sol-card">
          <div className="enrollment-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/education-academy-certification-curriculum.jpg"
              alt="Curriculum Overview"
              className="ps-main-image"
            />
          </div>

          <div>
            <h2 className="product-and-sol-sectionTitle">
              Globally Recognized Curriculum
            </h2>
            <p className="product-and-sol-section-text">
              Design, customize, and implement international curricula such as
              IB, Cambridge, or AP with structured learning outcomes and
              measurable results.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Framework alignment (IB, Cambridge, AP)</li>
              <li>✔ Subject & learning outcome mapping</li>
              <li>✔ Assessment & grading integration</li>
              <li>✔ Holistic and competency-based learning</li>
            </ul>
          </div>
        </div>

        {/* ===== FEATURES ===== */}
        <div className="ps-feature-grid">

          <FeatureCard
            typeClass="credentialing"
            backgroundColor="#e9fdf3"
            icon={icons.framework}
            title="Framework Alignment"
            description="Align your curriculum with global standards such as IB, Cambridge, or AP."
          />

          <FeatureCard
            typeClass="wallet"
            backgroundColor="#f3ecff"
            icon={icons.subjects}
            title="Subject Mapping"
            description="Define subjects, learning objectives, and competencies for structured delivery."
          />

          <FeatureCard
            typeClass="human-resources"
            backgroundColor="#f1f6ff"
            icon={icons.assessment}
            title="Assessment Integration"
            description="Integrate formative and summative assessments with grading systems."
          />

          <FeatureCard
            typeClass="education"
            backgroundColor="#fff3cc"
            icon={icons.competency}
            title="Competency-Based Learning"
            description="Promote skill-based, holistic learning beyond traditional textbooks."
          />

          <FeatureCard
            typeClass="marketing"
            backgroundColor="#ffe6dc"
            icon={icons.resources}
            title="Resource Management"
            description="Attach learning materials, textbooks, and digital resources."
          />

          <FeatureCard
            typeClass="analytics"
            backgroundColor="#eaf9fa"
            icon={icons.analytics}
            title="Curriculum Analytics"
            description="Track curriculum adoption, assessments, and student performance."
          />

        </div>

        {/* ===== CTA ===== */}
        <div className="ps-highlight-wrapper">
          <div className="ps-highlight-card">

            <div className="ps-highlight-header">
              <h2 className="ps-highlight-title">
                Develop World-Class Curriculum
              </h2>
              <p className="ps-highlight-subtitle">
                International standards built for future-ready schools
              </p>
            </div>

            <div className="ps-highlight-body">
              <p className="ps-highlight-text">
                Equip your institution with globally recognized frameworks that
                foster excellence and global readiness in students.
              </p>

              <div className="ps-button-group">
                <button
                  className="Demo-button"
                  onClick={() => navigate("/contact#Contact-form")}
                >
                  Request Curriculum Demo
                </button>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

/* ===== SHARED FEATURE CARD ===== */
const FeatureCard = ({
  icon,
  title,
  description,
  backgroundColor,
  typeClass
}) => (
  <div
    className={`card product-soluction-card ${typeClass}`}
    style={{ backgroundColor }}
  >
    <div className="card-overlay"></div>

    <div className="circle">
      <div className="ps-card-icon">{icon}</div>
    </div>

    <h3 className="ps-card-title">{title}</h3>
    <p className="product-soluction-card-text">{description}</p>
  </div>
);

/* ===== ICONS ===== */
const icons = {
  framework: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke="#5a5cff" strokeWidth="2" />
      <path d="M3 9h18M3 15h18" stroke="#5a5cff" strokeWidth="2" />
    </svg>
  ),
  subjects: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M4 6h16M4 12h16M4 18h16" stroke="#ff8c00" strokeWidth="2" />
    </svg>
  ),
  assessment: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="4" y="4" width="16" height="16" rx="2" stroke="#0ca85c" strokeWidth="2" />
      <path d="M8 12h8M8 16h5" stroke="#0ca85c" strokeWidth="2" />
    </svg>
  ),
  competency: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="#e74c3c" strokeWidth="2" />
      <path d="M8 12l2 2 4-4" stroke="#e74c3c" strokeWidth="2" />
    </svg>
  ),
  resources: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M4 3h16v18H4z" stroke="#6c5ce7" strokeWidth="2" />
      <path d="M4 9h16" stroke="#6c5ce7" strokeWidth="2" />
    </svg>
  ),
  analytics: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M4 20V10M10 20V6M16 20v-4" stroke="#0097e6" strokeWidth="2" />
    </svg>
  ),
};

export default InternationalCurriculumDevelopment;
